export function ninjaforms($) {
    document.addEventListener('click', e => {
        if(e.target.getAttribute('value') === 'Processing') {
            e.preventDefault();
            e.target.setAttribute('disabled', 'disabled');
        }
    });
}
